import dayjs from 'dayjs';
import { TEXTDATEFORMAT } from '@/utilities/time';

const formatSeason = (season) => {
  const { startDate, endDate } = season;
  const startsAt = dayjs.unix(startDate.seconds).format(TEXTDATEFORMAT);
  const endsAt = dayjs.unix(endDate.seconds).format(TEXTDATEFORMAT);
  return {
    ...season,
    startsAt,
    endsAt,
  };
};

const getAllSeasons = ({ state }) => {
  const { seasons } = state;
  if (seasons) {
    return seasons.map(season => formatSeason(season));
  }
  return null;
};


const getSeason = ({ state, id }) => {
  const { seasons } = state;
  const isSameNumber = season => parseInt(season.id, 10) === parseInt(id, 10);
  const foundSeason = seasons && seasons.find(season => isSameNumber(season));
  return foundSeason && formatSeason(foundSeason);
};

export default {
  getAllSeasons: state => getAllSeasons({ state }),
  getSeason: state => id => getSeason({ state, id }),
};
